import { z } from 'zod';

const JsonValueSchema: z.ZodType<any> = z.lazy(() => 
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema),
    z.record(JsonValueSchema),
  ])
);

export const PackageSchema = z.object({
  id: z.number(),
  sequential_number: z.number(),
  tracking: z.string().nullable(),
  guest_name: z.string().nullable(),
  entry_date: z.string(),
  status: z.string().nullable(),
  room_number: z.string().nullable(),
  receiver_name: z.string().nullable(),
  signature: z.string().nullable(),
  last_updated_by: z.string().nullable(),
  is_deleted: z.boolean(),
  deletion_requested_at: z.string().nullable(),
  observations: JsonValueSchema.nullable(),
  history: JsonValueSchema.nullable(),
});

export const PackageArraySchema = z.array(PackageSchema);

export type Package = z.infer<typeof PackageSchema>; 